// src/store/modules/homePageConfig.js (原 bannerConfig.js)
import frontServer from '@/services/FrontManage';
// 假设 customizeServer 包含更新所有自定义配置的方法
import customizeServer from '@/services/CustomizeManage'; 

const getDefaultShopTitleConfig = () => ({
  mainText: '精品搜尋',
  mainFontSize: 'clamp(3rem, 7vw, 6rem)',
  mainFontColor: 'transparent', // 示例，实际颜色由渐变文字效果决定
  mainFontFamily: "'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif",
  mainFontWeight: '600',
  mainFontStyle: 'normal',
  subText: 'Boutique Search',
  subFontSize: 'clamp(1.8rem, 4vw, 3.5rem)',
  subFontColor: 'transparent', // 示例
  subFontFamily: "'Arial', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
  subFontWeight: '400',
  subFontStyle: 'normal',
});


const state = {
  // Banner 配置 (保持原样)
  bannerConfig: {
    title: {
      text: '探索時尚魅力',
      fontSize: '3rem',
      fontColor: '#FFFFFF',
      fontFamily: "'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif",
      fontWeight: '700',
      fontStyle: 'normal',
    },
    subtitle1: { text: '拒絕平庸，只為自己發聲的潮流' },
    subtitle2: { text: 'LUKE潮流，定義你與眾不同的質感生活' },
    subtitle: {
      fontSize: '1.5rem', fontColor: '#FFFFFF',
      fontFamily: "'Arial', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
      fontWeight: '400', fontStyle: 'normal',
    },
    animationClass: 'animate__animated animate__flipInX',
  },
  isBannerConfigLoaded: false, // 原 isFontConfigLoaded

  // Shop 标题配置 (新增)
  shopTitleConfig: getDefaultShopTitleConfig(),
  isShopTitleConfigLoaded: false,
};

const mutations = {
  // --- Banner Mutations (基本保持原样，注意 state 路径) ---
  SET_BANNER_CONFIG(state, payload) {
    const cfg = state.bannerConfig;
    cfg.title.text = payload.banner_title_text || cfg.title.text;
    cfg.title.fontSize = payload.banner_title_font_size || cfg.title.fontSize;
    cfg.title.fontColor = payload.banner_title_font_color || cfg.title.fontColor;
    cfg.title.fontFamily = payload.banner_title_font_family || cfg.title.fontFamily;
    cfg.title.fontWeight = payload.banner_title_font_weight || cfg.title.fontWeight;
    cfg.title.fontStyle = payload.banner_title_font_style || cfg.title.fontStyle;
    cfg.subtitle1.text = payload.banner_subtitle1_text || cfg.subtitle1.text;
    cfg.subtitle2.text = payload.banner_subtitle2_text || cfg.subtitle2.text;
    cfg.subtitle.fontSize = payload.banner_subtitle_font_size || cfg.subtitle.fontSize;
    cfg.subtitle.fontColor = payload.banner_subtitle_font_color || cfg.subtitle.fontColor;
    cfg.subtitle.fontFamily = payload.banner_subtitle_font_family || cfg.subtitle.fontFamily;
    cfg.subtitle.fontWeight = payload.banner_subtitle_font_weight || cfg.subtitle.fontWeight;
    cfg.subtitle.fontStyle = payload.banner_subtitle_font_style || cfg.subtitle.fontStyle;
    cfg.animationClass = payload.banner_animation_class || cfg.animationClass;
  },
  SET_BANNER_CONFIG_LOADED(state, loaded) {
    state.isBannerConfigLoaded = loaded;
  },
  UPDATE_BANNER_CONFIG_FROM_ADMIN(state, newBannerConfig) {
    if (newBannerConfig.title) state.bannerConfig.title = { ...state.bannerConfig.title, ...newBannerConfig.title };
    if (newBannerConfig.subtitle1) state.bannerConfig.subtitle1 = { ...state.bannerConfig.subtitle1, ...newBannerConfig.subtitle1 };
    if (newBannerConfig.subtitle2) state.bannerConfig.subtitle2 = { ...state.bannerConfig.subtitle2, ...newBannerConfig.subtitle2 };
    if (newBannerConfig.subtitle) state.bannerConfig.subtitle = { ...state.bannerConfig.subtitle, ...newBannerConfig.subtitle };
    if (newBannerConfig.animationClass) state.bannerConfig.animationClass = newBannerConfig.animationClass;
  },

  // --- Shop Title Mutations (新增) ---
  SET_SHOP_TITLE_CONFIG(state, payload) {
    const cfg = state.shopTitleConfig;
    cfg.mainText = payload.shop_title_main_text || cfg.mainText;
    cfg.mainFontSize = payload.shop_title_main_font_size || cfg.mainFontSize;
    cfg.mainFontColor = payload.shop_title_main_font_color || cfg.mainFontColor;
    cfg.mainFontFamily = payload.shop_title_main_font_family || cfg.mainFontFamily;
    cfg.mainFontWeight = payload.shop_title_main_font_weight || cfg.mainFontWeight;
    cfg.mainFontStyle = payload.shop_title_main_font_style || cfg.mainFontStyle;
    cfg.subText = payload.shop_title_sub_text || cfg.subText;
    cfg.subFontSize = payload.shop_title_sub_font_size || cfg.subFontSize;
    cfg.subFontColor = payload.shop_title_sub_font_color || cfg.subFontColor;
    cfg.subFontFamily = payload.shop_title_sub_font_family || cfg.subFontFamily;
    cfg.subFontWeight = payload.shop_title_sub_font_weight || cfg.subFontWeight;
    cfg.subFontStyle = payload.shop_title_sub_font_style || cfg.subFontStyle;
  },
  SET_SHOP_TITLE_CONFIG_LOADED(state, loaded) {
    state.isShopTitleConfigLoaded = loaded;
  },
  UPDATE_SHOP_TITLE_CONFIG_FROM_ADMIN(state, newShopConfig) {
    state.shopTitleConfig = { ...state.shopTitleConfig, ...newShopConfig };
  }
};

const actions = {
  // --- Banner Actions (基本保持原样，注意 commit 名称) ---
  async fetchBannerConfigs({ commit, state }) { // 原 fetchFontConfigs
    if (state.isBannerConfigLoaded && Object.keys(state.bannerConfig.title).length > 0) { // 更严谨的检查
      console.log('Banner config already loaded in store.');
      // return; // 如果希望每次都刷新，可以注释掉
    }
    try {
      const response = await frontServer.GetFront(); // 假设此 API 返回所有 Banner 相关配置
      if (response && typeof response === 'object') {
        commit('SET_BANNER_CONFIG', response);
      }
      commit('SET_BANNER_CONFIG_LOADED', true);
    } catch (error) {
      console.error('Failed to fetch banner configs:', error);
      commit('SET_BANNER_CONFIG_LOADED', true);
    }
  },
  updateBannerConfigFromAdmin({ commit }, newBannerConfig) { // 原 updateFontConfigFromAdmin
    commit('UPDATE_BANNER_CONFIG_FROM_ADMIN', newBannerConfig);
  },

  // --- Shop Title Actions (新增) ---
  async fetchShopTitleConfigs({ commit, state }) {
    if (state.isShopTitleConfigLoaded && state.shopTitleConfig.mainText !== '精品搜尋') { // 简单检查是否已加载非默认值
       console.log('Shop title config already loaded in store.');
      // return;
    }
    try {
      // 假设 customizeServer.GetShopTitleConfig() 或 frontServer.GetFront() 返回 Shop 标题配置
      // 你需要一个能获取 Shop 标题配置的 API
      const response = await frontServer.GetFront(); // 或者一个专门的 API
      if (response && typeof response === 'object') {
        commit('SET_SHOP_TITLE_CONFIG', response);
      }
      commit('SET_SHOP_TITLE_CONFIG_LOADED', true);
    } catch (error) {
      console.error('Failed to fetch shop title configs:', error);
      commit('SET_SHOP_TITLE_CONFIG_LOADED', true);
    }
  },
  updateShopTitleConfigFromAdmin({ commit }, newShopConfig) {
    commit('UPDATE_SHOP_TITLE_CONFIG_FROM_ADMIN', newShopConfig);
  }
};

const getters = {
  // Banner Getters
  bannerConfig: state => state.bannerConfig,
  isBannerConfigLoaded: state => state.isBannerConfigLoaded,

  // Shop Title Getters (新增)
  shopTitleConfig: state => state.shopTitleConfig,
  isShopTitleConfigLoaded: state => state.isShopTitleConfigLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};